<template>
    <div class="guest-container">
        <h2>Данные заказа</h2>
        <form class="guest-form" @submit.prevent="$emit('performInvoice',guestData)">
            <div class="guest-row-block">
                <div class="guest-input-block">
                    <input tabindex="1" v-model="name" autocomplete="off" class="form__input" name="sname" id="sname" type="text" required placeholder="Как к Вам обращаться"/>
                </div>
            </div>
            <div class="guest-row-block">
                <div id="dlbtype" class="guest-input-block radio">
                    <input tabindex="-1" v-if="shop.allowdlv" v-model="type" id="dlv" checked type="radio" value="1" name="dlbtype">
                    <label v-if="shop.allowdlv" class="radio-label" for="dlv">Доставка</label>

                    <input tabindex="-1" v-if="shop.allowta" v-model="type" id="ta" type="radio" value="0" name="dlbtype">
                    <label v-if="shop.allowta" class="radio-label" for="ta">Самовывоз</label>
                </div>
                <div class="guest-input-block">
                    <input tabindex="2" @focus="pfocus" autocomplete="off" class="form__input" required name="phone" id="phone" type="input" placeholder="Телефон" v-model="phone" @input="acceptPhone" />
                </div>
            </div>
            <div v-if="type == 1" class="guest-row-block">
                <div class="guest-input-block grow">
                    <input tabindex="3" v-model="address" autocomplete="off" @change="suggest" class="form__input" name="st" id="st" type="text" required placeholder="Адрес доставки"/>
                </div>                
            </div>
            <div v-if="delivery_zone && type == 1" class="guest-row-block">
                <div v-if="delivery_zone.result" class="guest-input-block" >
                    <div class="deliveryzone" id="deliveryzone">
                        <h4>
                            {{ zonetext }}
                        </h4>
                        <pre>
{{ zonedesc }}
                        </pre>
                    </div>

                </div>                
            </div>
            <div class="guest-row-block">
                <div class="guest-input-block">   
                    <input tabindex="4" v-model="comment" autocomplete="off" class="form__input" name="com" id="com" type="text" placeholder="Комментарий"/>
                </div>
                <div class="guest-input-block">   
                    <input tabindex="5" v-model="cashval" v-if="(ptype == 0) && (type == 1)" autocomplete="off" class="form__input" name="back" id="back" type="number" required placeholder="С какой суммы подготовить сдачу"/>
                </div>
            </div>
            <div class="guest-row-block">
                <div id="dlbtype" class="guest-input-block radio allowvertical">
                    <input tabindex="-1" v-if="shop.allowcash" v-model="ptype" id="nal" checked type="radio" value="0" name="paytype">
                    <label v-if="shop.allowcash" class="radio-label" for="nal">Оплатить наличными при получении</label>

                    <input tabindex="-1" v-if="shop.allowcard" v-model="ptype" id="card" type="radio" value="1" name="paytype">
                    <label v-if="shop.allowcard" class="radio-label" for="card">Оплатить картой при получении</label>

                    <input tabindex="-1" v-if="shop.allowonline" v-model="ptype" id="online" type="radio" value="2" name="paytype">
                    <label v-if="shop.allowonline" class="radio-label" for="online">Оплатить онлайн</label>
                </div>
            </div>
            <div class="validate-actions">
                <button type="reset" class="deny" @click="$emit('back')">&lt; Назад</button>
                <button v-if="canorder" type="submit" class="apply">Оформить заказ</button>
                <button type="submit" class="apply">111 заказ</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props:['ordersum', 'shop', 'api', 'canorder'],
    data(){
        return{
            name: '',
            phone: '',
            type: 1,
            address: '',
            cashval: '',
            comment: '',
            ptype: 1,
            latitude: undefined,
            longitude: undefined,
            unsuggestable: false,
            delivery_zone: {result:false},
            zonetext: '',
            zonedesc:''
        }
    },
    computed:{
        guestData(){
            let a = {
                guest:{
                    sname: this.name,
                    fname: '',
                    mname: '',
                    phone: this.phone,
                    address: this.address,
                    latitude: this.latitude,
                    longitude: this.longitude
                },
                order:{
                    type: +this.type,
                    ptype: +this.ptype,
                    comment: this.comment,
                    deliverat: this.deliverat,
                    cashval: this.cashval
                }
            }
            a.subdata = this.getQuery()
            return a
        }
    },
    watch:{
        phone(){
            if (this.phone.replace('+7', '').replace(/\D/g, '').length != 10) {
                document.getElementById('phone').setCustomValidity("Введите номер в формате +7 (XXX) XXX-XX-XX")
            } else {
                document.getElementById('phone').setCustomValidity("");
            }
        },
        cashval(val){
            if (val*100 < +this.ordersum) {
                document.getElementById('back').setCustomValidity("Введите сумму не меньше суммы заказа.")
            } else {
                document.getElementById('back').setCustomValidity("");
            }
        },
        type(val){
            if (val == 0) {
                this.canOrder = true
            } else {
                this.set_delivery_zone(this.delivery_zone)
            }
            this.$emit('revalidate', {OrderType: val, delivery_zone: this.delivery_zone})
        },
        guestData:{
            handler(val){
                localStorage.setItem('minidelivery_guestdata', JSON.stringify(val.guest))
            },
            deep: true
        }
    },
    methods:{
        hex2rgb(hex){
            return hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i ,(m, r, g, b) => '#' + r + r + g + g + b + b)
                .substring(1).match(/.{2}/g)
                .map(x => parseInt(x, 16))
        },
        cssrgb(r,g,b,a){
            return 'rgba('+r+','+g+','+b+','+a+')'
        },
        set_delivery_zone(val){
            this.delivery_zone = val
            this.$emit('revalidate', {OrderType: this.type, delivery_zone: this.delivery_zone})
            if (val == undefined) {
                return 0
            } else if (val.result == false) {
                return 0
            } else if (val.properties == undefined) {
                this.zonetext = 'Вне зоны доставки'
                this.zonedesc = ''
                document.getElementById('deliveryzone').style.backgroundColor = 'white'
                document.getElementById('deliveryzone').style.opacity = 1
                return 0
            } else {
                
                this.zonetext = val.properties.zonename
                this.zonedesc = val.properties.description
            
                this.$nextTick(() => {
                    document.getElementById('deliveryzone').style.backgroundColor = this.cssrgb(...this.hex2rgb(val.properties.fill), val.properties['fill-opacity']) 
                })
            }  
        },
        getQuery(){
            let query = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, pair) => {
                        const [key, value] = pair.map(decodeURIComponent);
                        return ({ ...obj, [key]: value })
                    }, {})
            let params = undefined

            if (query.minidlv) {
                let str = decodeURIComponent(escape(atob(query.minidlv)))
                params = JSON.parse(str)
            }
            return params
        },
        suggest(){
            if (this.address == ''){
                return 0
            }
            this.latitude = undefined
            this.longitude = undefined
            if (this.unsuggestable == true) return 0
            this.api.suggest(this.address)
                .then(async data => {
                    if (Object.keys(data.suggest).length != 0){
                        this.address = data.suggest.value
                        this.latitude = data.suggest.lat
                        this.longitude = data.suggest.lon
                    }
                    this.set_delivery_zone(data.delivery_zone)
                })
                .catch((val) => {
                    console.error(val)
                    /*this.unsuggestable = true*/
                    }
                )
        },
        acceptPhone: function () {
            var x = this.phone.replace('+7', '').replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
            this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] + (x[4] ? '-' + x[4] : '') : '');
            this.phone = '+7' + this.phone
        },
        pfocus(){
            if (this.phone == '') {
                this.phone = '+7'
            }
        },
        submitte(){
            alert('asdf')
        }
    },
    mounted(){
        if (this.shop.allowonline == 1){
            this.ptype = 2
        } else if (this.shop.allowcard == 1){
            this.ptype = 1
        } else if (this.shop.allowcash == 1){
            this.ptype = 0
        } else {
            this.$raise('Нет ни одного разрешеннго типа оплаты. Невозможно оформить заказ.')
            this.$emit('back')
            return 0
        }

        if (this.shop.allowdlv == 1) {
            this.type = 1
        } else if (this.shop.allowta == 1) {
            this.type = 0
        } else{
            this.$raise('Нет ни одного разрешенного типа заказа. Невозможно оформить заказ.')
            this.$emit('back')
            return 0
        }

        if (localStorage.getItem('minidelivery_guestdata')) {
            let old = JSON.parse(localStorage.getItem('minidelivery_guestdata'))
            this.name = old.sname,
            this.phone = old.phone,
            this.address = old.address,
            this.latitude = old.latitude,
            this.longitude = old.longitude
            this.suggest()
        }
    }
}
</script>